export default __webpack_public_path__ + "static/media/mp_checkbox_empty.cfcd6b10.svg";